const RenderItems = ({ items }: { items: string[] }) => {
  return items.map(
    (item, index) =>
      item && (
        <div
          key={index}
          className='inline-block rounded bg-ods-color-brand-primary-50 p-2 text-ods-font-styles-body-regular-xsmall'
        >
          {item}
        </div>
      ),
  );
};
export default RenderItems;
